import React from 'react'
import { Box, Paper, Typography, Button, Badge } from '@mui/material'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import BellGif from '../assets/alarm-unscreen.gif'

function CustomReminderAlert({
  title = 'Reminder',
  subtitle = 'Enter your daily reminder here...',
  count = 1,
  onClose = () => {},
  sx = {},
}) {
  return (
    <Paper
      elevation={3}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        p: { xs: 2, sm: 3 },
        borderRadius: 3,
        width: { xs: '100%', sm: 300 },
        bgcolor: 'background.paper',
        boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
        ...sx,
      }}
    >
      {/* Bell icon with badge */}
      <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {/* <NotificationsActiveIcon sx={{ color: '#ffd54f', fontSize: 100 }} /> */}
          <img src={BellGif} alt="Reminder Alert" style={{ width: 92, height: 92 }} />

        </Box>

      </Box>

      {/* Text and button */}
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 800 }}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {subtitle}
        </Typography>

        <Box sx={{ mt: 1 }}>
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              textTransform: 'none',
              bgcolor: '#ffc107',
              color: '#000',
              borderRadius: 10,
              px: 3,
              py: 0.5,
              fontWeight: 700,
              '&:hover': { bgcolor: '#ffb300' },
            }}
          >
            Close
          </Button>
        </Box>
      </Box>
    </Paper>
  )
}

export default CustomReminderAlert